import React, { useState } from 'react';

interface TickerSearchProps {
  onTickerSearch: (ticker: string) => void;
  currentTicker: string;
  onRefresh: () => void;
  isLoading: boolean;
}

const TickerSearch: React.FC<TickerSearchProps> = ({ onTickerSearch, currentTicker, onRefresh, isLoading }) => {
  const [searchTicker, setSearchTicker] = useState(currentTicker);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchTicker.trim()) {
      onTickerSearch(searchTicker.trim().toUpperCase());
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTicker(e.target.value);
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-4 mb-6">
      <h2 className="text-xl font-bold mb-4 text-gray-800">Stock Ticker Search</h2>
      <form onSubmit={handleSubmit} className="flex gap-3">
        <div className="flex-1">
          <input
            type="text"
            value={searchTicker}
            onChange={handleInputChange}
            placeholder="Enter stock ticker (e.g., TSLA, AAPL, MSFT)"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all duration-200"
          />
        </div>
        <button
          type="submit"
          className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 font-medium"
        >
          Search
        </button>
        <button
          type="button"
          onClick={onRefresh}
          disabled={isLoading}
          className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors font-medium"
        >
          <svg 
            className={`w-4 h-4 mr-2 ${isLoading ? 'animate-spin' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" 
            />
          </svg>
          {isLoading ? 'Refreshing...' : 'Refresh'}
        </button>
      </form>
      {currentTicker && (
        <div className="mt-3 text-sm text-gray-600">
          Currently viewing: <span className="font-semibold text-blue-600">{currentTicker}</span>
        </div>
      )}
    </div>
  );
};

export default TickerSearch;
